import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListOffersComponent } from './components/list-offers/list-offers.component';
import { SuggestionOffersComponent } from './components/suggestion-offers/suggestion-offers.component';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { ArchivedEsnOfferComponent } from './components/archived-esn-offer/archived-esn-offer.component';
import { ListOffersCandidatureComponent } from './components/list-offers-candidature/list-offers-candidature.component';
import { DetailOfferCandidatureComponent } from './components/detail-offer-candidature/detail-offer-candidature.component';
import { ContactlistofferComponent } from './components/contactlistoffer/contactlistoffer.component';
import { esnAbonneNonabonneeGuard } from '@core/guards/esn-abonne-nonabonnee.guard';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { SubscribedEsnGuard } from '@core/guards/subscribed.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'list-offres',
    pathMatch: 'full',
  },
  {
    path:'list-offres',
    component:ListOffersComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]

  },
  {
    path:'suggestions-offres/:id',
    component:SuggestionOffersComponent,
  },
  
  {
    path:'details-offer1/:id/:state',
    component:DetailsOfferComponent
  },
  {
    path:'details-offer1/:id',
    component:DetailsOfferComponent,
    canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'archived',
    component:ArchivedEsnOfferComponent,
    canActivate: [SubscribedEsnGuard],
  },
  {
    path:'candidature',
    component:ListOffersCandidatureComponent,
    // canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path:'details-offer-candidature/:id',
    component:DetailOfferCandidatureComponent
  },
  {
    path:'contact/:id',
    component:ContactlistofferComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EsnJobOfferRoutingModule { }
